import React from 'react'

import NKIcon from '@norkart/ikoner'
import NkaButton from 'nka-button'
import { datoFormatTall } from '../../../felles/utils/dato-format-tabell'
import 'nka-button/dist/style.css'

export default (leggTilVannmaaler, { data: maaler }) => {
    return (
        <div className="maaler-popup-content">
            <h4>Målerinformasjon</h4>
            <table className="Table" width="200px">
                <tbody>
                    <tr>
                        <td>Adresse:</td>
                        <td>
                            {maaler.Maaleradresse + (' ' + maaler.Husnummer) + maaler.Husbokstav}
                        </td>
                    </tr>
                    <tr>
                        <td>Målernummer:</td>
                        <td>{maaler.Maalernummer}</td>
                    </tr>
                    <tr>
                        <td>Avtaletype:</td>
                        <td>{maaler.Avtaletype}</td>
                    </tr>
                    <tr>
                        <td>Innstallasjonsdato:</td>
                        <td>{datoFormatTall(maaler.Installasjonsdato)}</td>
                    </tr>
                    <tr>
                        <td>Avlesertype:</td>
                        <td>{maaler.AvlesertypeTekst}</td>
                    </tr>
                </tbody>
            </table>
            {maaler.ErIArbeidsliste ? (
                <div>
                <NKIcon icon="info" color="nk-black" size="1" />
                
                
                 <div style={{  display: 'inline', verticalAlign:'super' }}>
                    <span>Er i en annen arbeidsliste</span>
                 
                 </div>
                 </div>
            ) : (
                <NkaButton className="add"  buttontype="primary" onClick={() => leggTilVannmaaler(maaler)}>
                    Legg til
                </NkaButton>
            )}
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/planlegging/arbeidsliste/rediger/VannmaalerPopup.jsx